import React, { Component, useEffect } from 'react'
import './HomePlateform.css'
import Article from '../Article/Article'
import { useSelector } from 'react-redux'


const HomePartnersArticles = (props) => {
    const {articlesItems} = useSelector((state) => state.articles)

    React.useEffect(() => {    
        return function cleanup() {
          document.body.classList.remove("discover");
        };
      });

        return(
            <>
                {articlesItems.map((articleItem,i)=>{
                    if (i == props.article_index)
                    return  <Article
                                key={articleItem.data_guid}
                                title={articleItem.data_blob.data_tier.article_title}
                                text={articleItem.data_blob.data_tier.article_text}
                                pictureURL={articleItem.data_blob.data_tier.article_photo}
                                article_link={articleItem.data_blob.data_tier.article_link}
                            />
                })}
            </>
        )
} 

export default HomePartnersArticles;